const ItemCategoriesSCP = [
    { name: "Cards", id: 0 },
    { name: "Weapons", id: 1 },
    { name: "Ammunition", id: 2 },
    { name: "Health", id: 3 },
    { name: "SCP items", id: 4 },
    { name: "Other", id: 5 }
];

export default ItemCategoriesSCP;